export const OPUrl = 'https://op-admin.i-ktv.com';
// export const OPUrl = 'https://pda-srv.i-ktv.com';
export const OMUrl = 'https://om.store.i-ktv.com';
// export const SRVUrl = 'http://www.new.srv.ccc:8080';
export const SRVUrl = 'https://new.srv.store.i-ktv.com';
export const CSUrl = 'https://dy.caishengwl.com';
export const uploadUrl = 'https://obs.ccea.i-ktv.com';
export const downUrl = 'https://service.platform.i-ktv.com';